import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "view-document"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "infos"
}
const _hoisted_6 = { class: "interactions" }
const _hoisted_7 = { class: "tag" }
const _hoisted_8 = {
  key: 0,
  class: "tag exceptions"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, "Documento", -1)
const _hoisted_10 = { class: "subtitle" }
const _hoisted_11 = {
  key: 0,
  class: "ai-summary-trigger"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_14 = {
  key: 0,
  class: "ai-summary"
}
const _hoisted_15 = { class: "document" }
const _hoisted_16 = { class: "interaction-creator" }
const _hoisted_17 = { class: "document__item" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "document__attachments"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", null, "DOCUMENTOS EM ANEXO", -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.5819 11.9999C15.5819 13.9799 13.9819 15.5799 12.0019 15.5799C10.0219 15.5799 8.42188 13.9799 8.42188 11.9999C8.42188 10.0199 10.0219 8.41992 12.0019 8.41992C13.9819 8.41992 15.5819 10.0199 15.5819 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<button class=\"tooltip\"><figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><g clip-path=\"url(#clip0_519_4148)\"><path d=\"M7.5 9.1665V14.1665L9.16667 12.4998\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.50065 14.1667L5.83398 12.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.3327 8.33317V12.4998C18.3327 16.6665 16.666 18.3332 12.4993 18.3332H7.49935C3.33268 18.3332 1.66602 16.6665 1.66602 12.4998V7.49984C1.66602 3.33317 3.33268 1.6665 7.49935 1.6665H11.666\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.3327 8.33317H14.9993C12.4993 8.33317 11.666 7.49984 11.666 4.99984V1.6665L18.3327 8.33317Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_519_4148\"><rect width=\"20\" height=\"20\" fill=\"white\"></rect></clipPath></defs></svg></figure></button>", 1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "ai-reply"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_29 = {
  key: 0,
  class: "ai-panel"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "ai-reply-prompt" }, "Instrução para a IA (opcional)", -1)
const _hoisted_31 = { class: "ai-panel__footer" }
const _hoisted_32 = {
  key: 0,
  class: "ai-panel__quota"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 3,
  class: "ai-compliance"
}
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_37 = {
  key: 0,
  class: "ai-compliance__result"
}
const _hoisted_38 = {
  key: 0,
  class: "ai-compliance__ok"
}
const _hoisted_39 = {
  key: 1,
  class: "ai-compliance__issues"
}
const _hoisted_40 = { key: 4 }
const _hoisted_41 = { key: 5 }
const _hoisted_42 = { key: 7 }
const _hoisted_43 = { key: 8 }
const _hoisted_44 = { key: 10 }
const _hoisted_45 = { key: 11 }
const _hoisted_46 = { key: 13 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)", -1)
const _hoisted_48 = { key: 14 }
const _hoisted_49 = ["id", "value", "checked", "onChange"]
const _hoisted_50 = ["for"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_52 = { key: 16 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)", -1)
const _hoisted_54 = { key: 17 }
const _hoisted_55 = ["id", "value", "checked", "onChange"]
const _hoisted_56 = ["for"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_58 = { key: 19 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)", -1)
const _hoisted_60 = { key: 20 }
const _hoisted_61 = ["value"]
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.5 9.08984H20.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 13.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 16.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 13.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 16.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 13.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 16.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "modal-date-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Data limite"),
  /*#__PURE__*/_createElementVNode("h2", null, "Prazo máximo para ser aceito.")
], -1)
const _hoisted_64 = { class: "transfer" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h1", null, "Transferir documento", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)", -1)
const _hoisted_67 = ["id", "value", "checked", "onChange"]
const _hoisted_68 = ["for"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Responsáveis "),
  /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)")
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h2", null, "Quem agora precisa ter acesso a esse documento? Você pode selecionar mais de uma pessoa.", -1)
const _hoisted_72 = ["id", "value", "checked", "onChange"]
const _hoisted_73 = ["for"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Conteúdo desse documento "),
  /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)")
], -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("h2", null, "Descreva os principais detalhes que irão ajudar aos interessados saber sobre o documento.", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h1", null, "Arquivo do documento", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h2", null, "Adicione um arquivo a esse documento, podendo ser DOC ou PDF.", -1)
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 24,
  class: "actions-doc"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("nav", null, [
  /*#__PURE__*/_createElementVNode("button", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "none",
        d: "M14.166 18.3335H5.83268C2.49935 18.3335 1.66602 17.5002 1.66602 14.1668V12.5002C1.66602 9.16683 2.49935 8.3335 5.83268 8.3335H14.166C17.4993 8.3335 18.3327 9.16683 18.3327 12.5002V14.1668C18.3327 17.5002 17.4993 18.3335 14.166 18.3335Z",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        fill: "none",
        d: "M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C13.75 1.6665 15 3.33317 15 5.83317",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        fill: "none",
        d: "M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ]),
    /*#__PURE__*/_createTextVNode(" Reabrir ")
  ])
], -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = ["data-doc-number"]
const _hoisted_85 = { class: "actions" }
const _hoisted_86 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "M14.166 18.3335H5.83268C2.49935 18.3335 1.66602 17.5002 1.66602 14.1668V12.5002C1.66602 9.16683 2.49935 8.3335 5.83268 8.3335H14.166C17.4993 8.3335 18.3327 9.16683 18.3327 12.5002V14.1668C18.3327 17.5002 17.4993 18.3335 14.166 18.3335Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C13.75 1.6665 15 3.33317 15 5.83317",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_90 = [
  _hoisted_87,
  _hoisted_88,
  _hoisted_89
]
const _hoisted_91 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "9",
  viewBox: "0 0 11 9",
  fill: "none"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_519_4047)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M3.87391 8.53798C3.77705 8.63467 3.64578 8.68897 3.50891 8.68897C3.37205 8.68897 3.24078 8.63467 3.14391 8.53798L0.227247 5.62132C0.155209 5.54941 0.0980586 5.464 0.0590649 5.36999C0.0200711 5.27597 0 5.17518 0 5.0734C0 4.97162 0.0200711 4.87083 0.0590649 4.77681C0.0980586 4.68279 0.155209 4.59739 0.227247 4.52548L0.592247 4.16132C0.73758 4.01603 0.934665 3.93441 1.14016 3.93441C1.34566 3.93441 1.54275 4.01603 1.68808 4.16132L3.50891 5.98048L8.42558 1.06382C8.57091 0.91853 8.768 0.836914 8.9735 0.836914C9.17899 0.836914 9.37608 0.91853 9.52141 1.06382L9.88641 1.42882C9.95845 1.50072 10.0156 1.58613 10.0546 1.68015C10.0936 1.77416 10.1137 1.87495 10.1137 1.97673C10.1137 2.07852 10.0936 2.1793 10.0546 2.27332C10.0156 2.36734 9.95845 2.45274 9.88641 2.52465L3.87391 8.53798Z"
  })
], -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_519_4047" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "10.1175",
      height: "7.85583",
      fill: "white",
      transform: "translate(0 0.833496)"
    })
  ])
], -1)
const _hoisted_94 = [
  _hoisted_92,
  _hoisted_93
]
const _hoisted_95 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M14.166 18.3335H5.83268C2.49935 18.3335 1.66602 17.5002 1.66602 14.1668V12.5002C1.66602 9.16683 2.49935 8.3335 5.83268 8.3335H14.166C17.4993 8.3335 18.3327 9.16683 18.3327 12.5002V14.1668C18.3327 17.5002 17.4993 18.3335 14.166 18.3335Z",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M5 8.33317V6.6665C5 3.90817 5.83333 1.6665 10 1.6665C13.75 1.6665 15 3.33317 15 5.83317",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_96 = ["disabled"]
const _hoisted_97 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path fill=\"none\" d=\"M8.33268 4.99984H11.666C13.3327 4.99984 13.3327 4.1665 13.3327 3.33317C13.3327 1.6665 12.4993 1.6665 11.666 1.6665H8.33268C7.49935 1.6665 6.66602 1.6665 6.66602 3.33317C6.66602 4.99984 7.49935 4.99984 8.33268 4.99984Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill=\"none\" d=\"M11.6667 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill=\"none\" d=\"M13.334 3.3501C16.109 3.5001 17.5007 4.5251 17.5007 8.33343V12.5001\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill=\"none\" d=\"M17.5 15.8335V18.3335H15\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path fill=\"none\" d=\"M12.5 13.3335L17.4667 18.3002\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_98 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" fill=\"none\" d=\"M0 0h24v24H0z\"></path><path fill=\"none\" d=\"M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3\"></path><path fill=\"none\" d=\"M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6\"></path><path fill=\"none\" d=\"M12 11v2a14 14 0 0 0 2.5 8\"></path><path fill=\"none\" d=\"M8 15a18 18 0 0 0 1.8 6\"></path><path fill=\"none\" d=\"M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95\"></path></svg>", 1)
const _hoisted_99 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path fill=\"none\" d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline fill=\"none\" points=\"14 2 14 8 20 8\"></polyline><line fill=\"none\" x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\"></line><line fill=\"none\" x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\"></line><polyline fill=\"none\" points=\"10 9 9 9 8 9\"></polyline></svg>", 1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("h1", null, "Informações", -1)
const _hoisted_101 = { class: "info" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("h1", null, "Histórico", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M6 9V2h12v7" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "6",
      y: "14",
      width: "12",
      height: "8",
      fill: "none"
    })
  ])
], -1)
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = { class: "print-header" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("h1", null, "Relatório de Histórico", -1)
const _hoisted_110 = { class: "historic" }
const _hoisted_111 = { class: "item" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { key: 2 }
const _hoisted_116 = { key: 3 }
const _hoisted_117 = {
  key: 0,
  class: "document-notes"
}
const _hoisted_118 = /*#__PURE__*/_createStaticVNode("<div class=\"document-notes__header\"><h1>Notas</h1><span class=\"document-notes__badge\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M12 5C5.63636 5 2 12 2 12C2 12 5.63636 19 12 19C18.3636 19 22 12 22 12C22 12 18.3636 5 12 5Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg> Visível apenas para você </span></div>", 1)
const _hoisted_119 = { class: "document-notes__list" }
const _hoisted_120 = { class: "document-notes__item-header" }
const _hoisted_121 = { class: "document-notes__title" }
const _hoisted_122 = { class: "document-notes__date" }
const _hoisted_123 = ["innerHTML"]
const _hoisted_124 = { key: 1 }
const _hoisted_125 = {
  key: 2,
  class: "viewers"
}
const _hoisted_126 = { class: "viewer" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("strong", null, "Visualizou o comunicado", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("path", {
  d: "M33.7569 42.6831C29.1852 43.0081 29.1852 49.6381 33.7569 49.9631H44.6119C45.9335 49.9631 47.1902 49.4865 48.1652 48.5981C51.3719 45.8031 49.6602 40.1698 45.4352 39.6498C43.9185 30.5065 30.6802 33.9731 33.8219 42.6831",
  fill: "#0071CF"
}, null, -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("path", {
  d: "M33.7569 42.6831C29.1852 43.0081 29.1852 49.6381 33.7569 49.9631H44.6119C45.9335 49.9631 47.1902 49.4865 48.1652 48.5981C51.3719 45.8031 49.6602 40.1698 45.4352 39.6498C43.9185 30.5065 30.6802 33.9731 33.8219 42.6831",
  fill: "#0071CF"
}, null, -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("path", {
  d: "M47.6673 23.9847V33.2363C47.6673 33.9297 46.5623 34.233 46.0856 33.7347C45.0673 32.673 43.789 31.8713 42.3157 31.4163C38.914 30.3547 34.9923 31.3947 32.5223 33.9513C30.9623 35.6197 30.1173 37.6997 30.074 39.953C30.074 40.343 29.879 40.6897 29.5756 40.928C28.0156 42.163 27.0623 44.0913 27.0623 46.3013V46.323C27.0623 47.0163 26.564 47.6447 25.8706 47.6447H15.904C9.53398 47.6663 4.33398 42.4663 4.33398 36.0747V13.9097C4.33398 8.62301 8.62398 4.33301 13.9107 4.33301H18.9373C22.469 4.33301 23.574 5.48134 24.9823 7.36634L28.0156 11.3963C28.6873 12.2847 28.774 12.393 30.0306 12.393H36.0756C41.2323 12.393 45.609 15.773 47.104 20.453C47.429 21.428 47.6023 22.4247 47.6456 23.4863C47.6673 23.638 47.6673 23.833 47.6673 23.9847Z",
  fill: "#0071CF"
}, null, -1)
const _hoisted_132 = [
  _hoisted_129,
  _hoisted_130,
  _hoisted_131
]
const _hoisted_133 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_198_1747)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z" })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_198_1747" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "15.794",
        height: "15.793",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_136 = {
  key: 1,
  class: "dates"
}
const _hoisted_137 = { class: "conclusion-note-modal" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Concluir documento")
], -1)
const _hoisted_139 = { class: "body" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, [
  /*#__PURE__*/_createTextVNode("Nota de conclusão "),
  /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)")
], -1)
const _hoisted_141 = {
  key: 0,
  class: "error-text"
}
const _hoisted_142 = ["disabled"]
const _hoisted_143 = ["src"]
const _hoisted_144 = {
  class: "protocol-content",
  id: "printable-protocol"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "icon-fingerprint" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "46",
    height: "46",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#090909",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M12 11v2a14 14 0 0 0 2.5 8" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M8 15a18 18 0 0 0 1.8 6" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95" })
  ])
], -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("h1", null, "Protocolo digital", -1)
const _hoisted_147 = { class: "row info-row" }
const _hoisted_148 = { class: "col" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "REFERENTE", -1)
const _hoisted_150 = { class: "value" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_152 = { class: "col" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, " ", -1)
const _hoisted_154 = { class: "value" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_157 = { class: "row info-row" }
const _hoisted_158 = { class: "col" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "VISUALIZADO EM", -1)
const _hoisted_160 = { class: "value" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_162 = { class: "col" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, " ", -1)
const _hoisted_164 = { class: "value" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_167 = { class: "row full info-row" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "USUÁRIO QUE VISUALIZOU", -1)
const _hoisted_169 = { class: "value" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_171 = { class: "row full protocol-number info-row" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "NÚMERO DO PROTOCOLO GERADO", -1)
const _hoisted_173 = { class: "value number" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2-2H5a2 2 0 0 1-2-2v-4" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  })
], -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 6 2 18 2 18 9" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "6",
    y: "14",
    width: "12",
    height: "8"
  })
], -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", { class: "footer-alert" }, [
  /*#__PURE__*/_createTextVNode(" O SETOR DE ORIGEM FOI NOTIFICADO QUE VOCÊ JÁ VISUALIZOU"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ESSE DOCUMENTO E RECEBEU O PROTOCOLO GERADO. ")
], -1)
const _hoisted_177 = { class: "protocols-list-content" }
const _hoisted_178 = { class: "modal-header-info" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("h2", null, "Protocolos Gerados", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 6 2 18 2 18 9" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "6",
    y: "14",
    width: "12",
    height: "8"
  })
], -1)
const _hoisted_181 = { class: "doc-reference" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("span", { class: "ref-label" }, "REFERENTE AO:", -1)
const _hoisted_183 = { class: "ref-value" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Acompanhe quais organizações já visualizaram e geraram protocolo para este documento.", -1)
const _hoisted_185 = { class: "protocols-grid" }
const _hoisted_186 = { class: "card-header" }
const _hoisted_187 = { class: "org-name" }
const _hoisted_188 = { class: "header-right" }
const _hoisted_189 = { class: "protocol-badge" }
const _hoisted_190 = { class: "card-actions" }
const _hoisted_191 = ["onClick"]
const _hoisted_192 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2-2H5a2 2 0 0 1-2-2v-4" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  })
], -1)
const _hoisted_193 = [
  _hoisted_192
]
const _hoisted_194 = ["onClick"]
const _hoisted_195 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 6 2 18 2 18 9" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "6",
    y: "14",
    width: "12",
    height: "8"
  })
], -1)
const _hoisted_196 = [
  _hoisted_195
]
const _hoisted_197 = { class: "card-body" }
const _hoisted_198 = { class: "info-item" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Visualizado por", -1)
const _hoisted_200 = { class: "info-value" }
const _hoisted_201 = {
  class: "info-item",
  style: {"text-align":"right"}
}
const _hoisted_202 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Data e Hora", -1)
const _hoisted_203 = { class: "info-value" }

import { ref, onMounted, computed, watch } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import MyOptions from '@/components/options/MyOptions.vue'
import TextEditor from '@/components/input/TextEditor.vue'
import FileUploader from '@/components/input/FileUploader.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { DocumentModel, DocumentFileModel } from '@/models/DocumentModel'
import DocumentLogActionEnum, { documentLogActionTranslations } from '@/enums/DocumentLogActionEnum'
import { OrganizationModel } from '@/models/OrganizationModel'
import { UserModel } from '@/models/UserModel'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import DocumentStatusEnum, { documentStatusTranslations } from '@/enums/DocumentStatusEnum'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import { user, hasAiModule } from '@/global/states/GlobalState'
import { toast } from 'vue3-toastify'
import MyTags from '@/components/tag/MyTags.vue'
import DocumentTagTypeEnum from '@/enums/DocumentTags/DocumentTagTypeEnum'
import useDocument from '@/hooks/documents/useDocument'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'

const BRAZIL_TIMEZONE = 'America/Sao_Paulo'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDocument',
  props: {
    id: {}
  },
  setup(__props: any) {

const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const document = ref<DocumentModel>()
const organizations = ref<OrganizationModel[]>()
const users = ref<UserModel[]>()
const limitDateValue = ref('')
const updatePayload = ref<Partial<{content?: string, limit_date?: string, files: File[], responsibles: UserModel[], organizations: OrganizationModel[]}>>({ files: [] })
const isDatePickerModalOpen = ref(false)
const props = __props
const documentViews = computed(() => document.value?.logs.filter(log => log.action == DocumentLogActionEnum.VIEW) ?? [])
const isUpdatingDocument = ref(false)
const isFileVisualizerOpen = ref(false)
const fileVisualizerSrc = ref('')
const mentions = computed<string[]>(() => (document.value?.tags.filter((tag) => tag.type === DocumentTagTypeEnum.MENTION).map((tag) => tag.title)) ?? [])
const keywords = computed<string[]>(() => (document.value?.tags.filter((tag) => tag.type === DocumentTagTypeEnum.KEYWORD).map((tag) => tag.title)) ?? [])

const { getAllowedUsersToTransfer, getAbilities, isDocumentOpen } = useDocument()
const isDocumentOpenValue = computed(() => document.value ? isDocumentOpen(document.value) : false)
const abilities = computed(() => getAbilities(user.value, document.value))
const usersToTransfer = computed(() => getAllowedUsersToTransfer(user.value, document.value, users.value, updatePayload.value.organizations))

const isPayloadContentEmpty = computed(() => {
  const content = updatePayload.value.content ?? ''
  const strippedContent = content.replace(/<[^>]*>/g, '').trim()
  return strippedContent === ''
})

const currentDocumentResponsibles = computed(() => document.value?.responsibles ?? [])
const currentDocumentOrganizations = computed(() => document.value?.organizations ?? [])

function areIdSetsEqual (a: { id: number }[], b: { id: number }[]): boolean {
  if (a.length !== b.length) return false
  const bIds = new Set(b.map((item) => item.id))
  return a.every((item) => bIds.has(item.id))
}

const isResponsibleChanged = computed(() => {
  return !areIdSetsEqual(currentDocumentResponsibles.value, updatePayload.value.responsibles ?? [])
})

const isOrganizationChanged = computed(() => {
  return !areIdSetsEqual(currentDocumentOrganizations.value, updatePayload.value.organizations ?? [])
})

const isLimitDateChanged = computed(() => {
  if (!updatePayload.value.limit_date) return false
  const docLimitDate = document.value?.limit_date?.slice(0, 10)
  return updatePayload.value.limit_date !== docLimitDate
})

const shouldTransfer = computed(() => {
  return (isResponsibleChanged.value || isOrganizationChanged.value) &&
    !!updatePayload.value.responsibles?.length &&
    !!updatePayload.value.organizations?.length
})

const hasIncompleteTransfer = computed(() => {
  const hasOrganizations = !!updatePayload.value.organizations?.length
  const hasResponsibles = !!updatePayload.value.responsibles?.length
  return hasOrganizations !== hasResponsibles
})

const hasChanges = computed(() => {
  if (hasIncompleteTransfer.value) return false
  const hasInteractionChange = !isPayloadContentEmpty.value || !!updatePayload.value.files?.length
  return hasInteractionChange || isLimitDateChanged.value || shouldTransfer.value
})

function toggleUpdateOrganization (organization: OrganizationModel, checked: boolean): void {
  const current = updatePayload.value.organizations ?? []
  if (checked) {
    if (!current.some((o) => o.id === organization.id)) {
      updatePayload.value.organizations = [...current, organization]
    }
  } else {
    updatePayload.value.organizations = current.filter((o) => o.id !== organization.id)
    updatePayload.value.responsibles = (updatePayload.value.responsibles ?? []).filter((r) => r.organization_id !== organization.id)
  }
}

function toggleUpdateResponsible (responsible: UserModel, checked: boolean): void {
  const current = updatePayload.value.responsibles ?? []
  if (checked) {
    if (!current.some((r) => r.id === responsible.id)) {
      updatePayload.value.responsibles = [...current, responsible]
    }
  } else {
    updatePayload.value.responsibles = current.filter((r) => r.id !== responsible.id)
  }
}

function resetUpdatePayload (): void {
  if (!document.value) return
  updatePayload.value = {
    files: [],
    responsibles: [],
    organizations: []
  }
}

function getDocument (): void {
  axios.get(`api/documents/${props.id}`)
    .then((res: AxiosResponse<DocumentModel>) => {
      document.value = res.data
      resetUpdatePayload()
      if (res.data.newly_created_protocol) {
        isProtocolModalOpen.value = true
      }
    })
}

function getOrganizations (): void {
  axios.get('/api/organizations')
    .then((res) => {
      organizations.value = res.data
    })
}

function getUsers (): void {
  axios.get('/api/users')
    .then((res) => {
      users.value = res.data
    })
}

function updateDocument (status?: DocumentStatusEnum): void {
  isUpdatingDocument.value = true

  if (status) {
    const payload: Record<string, unknown> = { status: status, limit_date: updatePayload.value.limit_date }
    if (status === DocumentStatusEnum.COMPLETED && !isConclusionNoteEmpty.value) {
      payload.content = conclusionNote.value
    }
    axios.patch(`/api/documents/${document.value!.id}`, payload)
      .then((res: AxiosResponse<{document: DocumentModel}>) => {
        document.value = res.data.document
        if (status === DocumentStatusEnum.COMPLETED) {
          conclusionNote.value = ''
          showConclusionNoteError.value = false
        }
      }).finally(() => {
        isConfirmCompleteDocumentModal.value = false
        isUpdatingDocument.value = false
        toast.success(`Documento ${status == DocumentStatusEnum.UNDER_REVIEW ? 'reaberto' : 'finalizado'}`)
      })
  } else {
    const willTransfer = shouldTransfer.value
    const payload: Record<string, unknown> = { ...updatePayload.value }
    delete payload.responsibles
    delete payload.organizations
    if (willTransfer) {
      payload.responsible_ids = updatePayload.value.responsibles!.map((r) => r.id)
      payload.organization_ids = updatePayload.value.organizations!.map((o) => o.id)
    }
    if (isPayloadContentEmpty.value) {
      delete payload.content
    }
    if (!isLimitDateChanged.value) {
      delete payload.limit_date
    }
    axios.patch(`/api/documents/${document.value!.id}`, payload)
      .then((res: AxiosResponse<{document: DocumentModel}>) => {
        document.value = res.data.document
        resetUpdatePayload()
      }).finally(() => {
        isTransferDocumentModalOpen.value = false
        isUpdatingDocument.value = false
        toast.success(willTransfer ? 'Documento transferido' : 'Nova interação adicionada')
      })
  }
}

/* AI COMPLIANCE REVIEW */
const isReviewingCompliance = ref<boolean>(false)
const complianceResult = ref<{ ok: boolean, issues: string[] }>()

function reviewCompliance (): void {
  if (!updatePayload.value.content || isReviewingCompliance.value) return

  isReviewingCompliance.value = true

  const body = new FormData()
  body.append('content', updatePayload.value.content)
  if (document.value?.type) body.append('type', document.value.type as string)

  axios.post('/api/documents/ai-review-compliance', body)
    .then((res) => {
      complianceResult.value = res.data
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível revisar o documento com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isReviewingCompliance.value = false
      getAiUsage()
    })
}
/* AI COMPLIANCE REVIEW */

/* AI SUMMARIZATION */
const isSummarizingDocument = ref<boolean>(false)
const documentSummary = ref<string>('')

function summarizeDocument (): void {
  if (!document.value || isSummarizingDocument.value) return

  isSummarizingDocument.value = true

  const content = document.value.interactions.map((interaction) => interaction.content).join('\n')
  const body = new FormData()
  body.append('content', content)

  axios.post('/api/ai/summarize-content', body)
    .then((res) => {
      documentSummary.value = res.data.summary
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar o resumo com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isSummarizingDocument.value = false
      getAiUsage()
    })
}
/* AI SUMMARIZATION */

/* AI REPLY SUGGESTION */
const isAiReplyPanelOpen = ref<boolean>(false)
const aiReplyPrompt = ref<string>('')
const isSuggestingAiReply = ref<boolean>(false)
const aiUsage = ref<{ limit: number, used: number, remaining: number }>()

function getAiUsage (): void {
  axios.get('/api/documents/ai-generate-content/usage')
    .then((res) => {
      aiUsage.value = res.data
    })
}

function suggestAiReply (): void {
  if (!document.value || isSuggestingAiReply.value) return

  isSuggestingAiReply.value = true

  const payload = new FormData()
  if (aiReplyPrompt.value.trim()) payload.append('prompt', aiReplyPrompt.value.trim())

  axios.post(`/api/documents/${document.value.id}/ai-suggest-reply`, payload)
    .then((res) => {
      updatePayload.value.content = res.data.content
      aiReplyPrompt.value = ''
      isAiReplyPanelOpen.value = false
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar a sugestão de resposta com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isSuggestingAiReply.value = false
      getAiUsage()
    })
}
/* AI REPLY SUGGESTION */

async function visualizeFile (file: DocumentFileModel) {
  isFileVisualizerOpen.value = true
  fileVisualizerSrc.value = ''

  try {
    const response = await axios.get(`/api/documents/get-file-content/${file.id}`, { responseType: 'blob' })
    fileVisualizerSrc.value = URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  } catch (error) {
    console.error('Erro ao buscar o documento:', error)
    return ''
  }
}

function downloadFile (event: Event, file: DocumentFileModel): void {
  event.preventDefault()
  axios.get(`/api/documents/get-file-content/${file.id}`, { responseType: 'blob' })
    .then(response => {
      const url = URL.createObjectURL(new Blob([response.data]))

      const link = window.document.createElement('a')
      link.href = url
      link.setAttribute('download', file.name)
      link.style.display = 'none'
      window.document.body.appendChild(link)
      link.click()
      window.document.body.removeChild(link)
    })
    .catch(error => {
      console.error('Erro ao buscar o documento:', error)
    })
}

function printHistory (): void {
  window.print()
}

function printProtocolFile (protocol?: ProtocolModel): void {
  const targetProtocol = protocol && protocol.id ? protocol : (document.value?.current_protocol || document.value?.newly_created_protocol)
  if (!targetProtocol || !document.value) return

  const pad = String(targetProtocol.number).padStart(3, '0')
  const acronym = targetProtocol.organization?.acronym || ''
  const numberStr = acronym ? `${pad} - ${acronym}` : pad
  const dateStr = formatBrazilDate(targetProtocol.created_at)
  const timeStr = formatBrazilTime(targetProtocol.created_at)
  const userStr = `${targetProtocol.creator?.name || ''} ${targetProtocol.creator?.last_name || ''}`

  const printWindow = window.open('', '', 'height=600,width=800')
  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Protocolo Digital</title>
          <style>
            body { font-family: sans-serif; display: flex; justify-content: center; padding: 40px; }
            .protocol-wrapper { width: 400px; border: 1px solid #ccc; padding: 30px; border-radius: 10px; }
            .row { display: flex; justify-content: space-between; margin-bottom: 10px; }
            .col { display: flex; flex-direction: column; }
            .label { font-size: 10px; color: #666; text-transform: uppercase; margin-bottom: 4px; }
            .value { font-size: 14px; color: #000; line-height: 1.4; }
            .value strong { font-weight: 700; font-size: 15px; }
            .divider { border-top: 1.5px dashed #000; margin: 15px 0; }
            .protocol-number { font-size: 32px; font-weight: bold; }
            .text-center { text-align: center; }
            h1 { margin: 0 0 20px 0; text-align: center; font-size: 26px; font-weight: 800; }
            .footer-alert { background: #E8F0EA; padding: 20px; text-align: center; font-size: 11px; font-weight: bold; margin-top: 20px; border-radius: 8px; }
          </style>
        </head>
        <body>
          <div class="protocol-wrapper">
            <h1>Protocolo digital</h1>
            <div class="row">
              <div class="col">
                <span class="label">REFERENTE</span>
                <span class="value">Documento<br><strong>${document.value.number}</strong></span>
              </div>
              <div class="col">
                <span class="label">&nbsp;</span>
                <span class="value">Ofício/portaria<br><strong>${document.value.physical_document_number || '-'}</strong></span>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row">
              <div class="col">
                <span class="label">VISUALIZADO EM</span>
                <span class="value">Data<br><strong>${dateStr}</strong></span>
              </div>
              <div class="col">
                <span class="label">&nbsp;</span>
                <span class="value">Horas<br><strong>${timeStr}</strong></span>
              </div>
            </div>
            <div class="divider"></div>
            <div class="row" style="flex-direction: column;">
              <span class="label">USUÁRIO QUE VISUALIZOU</span>
              <span class="value"><strong>${userStr}</strong></span>
            </div>
            <div class="divider"></div>
            <div class="row" style="flex-direction: column;">
              <span class="label">NÚMERO DO PROTOCOLO GERADO</span>
              <span class="value protocol-number"><strong>${numberStr}</strong></span>
            </div>
            <div class="footer-alert">
              O SETOR DE ORIGEM FOI NOTIFICADO QUE VOCÊ JÁ VISUALIZOU<br>ESSE DOCUMENTO E RECEBEU O PROTOCOLO GERADO.
            </div>
          </div>
        </body>
      </html>
    `)
    printWindow.document.close()
    printWindow.focus()
    setTimeout(() => {
      printWindow.print()
      printWindow.close()
    }, 250)
  }
}

function downloadProtocolFile (protocol?: ProtocolModel): void {
  printProtocolFile(protocol) // Default to print since saving as PDF typically uses print to PDF
}

function printAllProtocols (): void {
  if (!document.value || !document.value.protocols?.length) return

  const docNumber = document.value.number
  const physicalDoc = document.value.physical_document_number || '-'
  
  let rowsHtml = ''
  document.value.protocols.forEach(protocol => {
    const pad = String(protocol.number).padStart(3, '0')
    const acronym = protocol.organization?.acronym || ''
    const numberStr = acronym ? `${pad} - ${acronym}` : pad
    const dateStr = formatBrazilDate(protocol.created_at)
    const timeStr = formatBrazilTime(protocol.created_at)
    const userStr = `${protocol.creator?.name || ''} ${protocol.creator?.last_name || ''}`
    const orgStr = `${protocol.organization?.name || ''} (${acronym})`
    
    rowsHtml += `
      <tr>
        <td><strong>${numberStr}</strong></td>
        <td>${orgStr}</td>
        <td>${userStr}</td>
        <td>${dateStr} às ${timeStr}</td>
      </tr>
    `
  })

  const printWindow = window.open('', '', 'height=600,width=800')
  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Relatório de Protocolos - Documento ${docNumber}</title>
          <style>
            body { font-family: sans-serif; padding: 40px; color: #000; }
            .header { text-align: center; margin-bottom: 30px; }
            h1 { margin: 0 0 10px 0; font-size: 24px; }
            .doc-info { font-size: 14px; color: #555; }
            .doc-info strong { color: #000; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 12px; text-align: left; font-size: 14px; }
            th { background-color: #f5f5f5; font-weight: bold; text-transform: uppercase; font-size: 12px; }
            td strong { color: #1A5D2A; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Relatório de Protocolos Gerados</h1>
            <div class="doc-info">
              Documento: <strong>${docNumber}</strong> &nbsp;|&nbsp; Ofício/Portaria: <strong>${physicalDoc}</strong>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Protocolo</th>
                <th>Órgão/Secretaria</th>
                <th>Visualizado por</th>
                <th>Data e Hora</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
        </body>
      </html>
    `)
    printWindow.document.close()
    printWindow.focus()
    setTimeout(() => {
      printWindow.print()
      printWindow.close()
    }, 250)
  }
}

onMounted(() => {
  getDocument()
  getOrganizations()
  getUsers()
  getAiUsage()
})

watch([organizations, users], () => {
  if (!document.value) return

  if (organizations.value && updatePayload.value.organizations?.length) {
    updatePayload.value.organizations = updatePayload.value.organizations.map((org) => {
      return organizations.value?.find((o) => o.id === org.id) ?? org
    })
  }

  if (users.value && updatePayload.value.responsibles?.length) {
    updatePayload.value.responsibles = updatePayload.value.responsibles.map((responsible) => {
      return users.value?.find((u) => u.id === responsible.id) ?? responsible
    })
  }
})

/* Alert modal variables. */
const isConfirmCompleteDocumentModal = ref<boolean>(false)
const isTransferDocumentModalOpen = ref<boolean>(false)
const isProtocolModalOpen = ref<boolean>(false)
const isProtocolsListModalOpen = ref<boolean>(false)
const isConclusionNoteModalOpen = ref<boolean>(false)
const conclusionNote = ref<string>('')
const conclusionNoteEditorKey = ref<number>(0)
const showConclusionNoteError = ref<boolean>(false)

const isConclusionNoteEmpty = computed(() => {
  const content = conclusionNote.value ?? ''
  const strippedContent = content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim()
  return strippedContent === ''
})

function openConclusionNoteModal (): void {
  showConclusionNoteError.value = false
  conclusionNoteEditorKey.value++
  isConclusionNoteModalOpen.value = true
}

function closeConclusionNoteModal (open: boolean): void {
  if (open) return
  isConclusionNoteModalOpen.value = false
  showConclusionNoteError.value = false
  conclusionNote.value = ''
}

function confirmConclusionNote (): void {
  if (isConclusionNoteEmpty.value) {
    showConclusionNoteError.value = true
    return
  }
  isConclusionNoteModalOpen.value = false
  isConfirmCompleteDocumentModal.value = true
}

const formatDate = (date: string) => {
  const [year, mouth, day] = date.split('-')
  return `${day}/${mouth}/${year}`
}

const formatBrazilDate = (isoDate: string): string => {
  return new Date(isoDate).toLocaleDateString('pt-BR', { timeZone: BRAZIL_TIMEZONE })
}

const formatBrazilTime = (isoDate: string): string => {
  const time = new Date(isoDate).toLocaleTimeString('pt-BR', { timeZone: BRAZIL_TIMEZONE, hour: '2-digit', minute: '2-digit' })
  return time.replace(':', 'h ') + 'min'
}

return (_ctx: any,_cache: any) => {
  return (document.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "back"
        }, _hoisted_4),
        (document.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["stats", {'reopen': abilities.value.reopenDocument, 'close': isDocumentOpenValue.value && abilities.value.completeDocument, 'block': !(isDocumentOpenValue.value && abilities.value.completeDocument && abilities.value.reopenDocument && !abilities.value.transferDocument)}])
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(document.value.number), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tag processing", document.value.status])
                  }, _toDisplayString(_unref(documentStatusTranslations)[document.value.status]), 3),
                  (document.value.is_exception)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Exceções"))
                    : _createCommentVNode("", true)
                ], 2),
                _hoisted_9,
                _createElementVNode("h2", _hoisted_10, _toDisplayString(document.value.title), 1),
                (_unref(hasAiModule))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ai-toggle-button",
                        disabled: isSummarizingDocument.value,
                        onClick: summarizeDocument
                      }, [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(isSummarizingDocument.value ? 'Resumindo...' : 'Resumir com IA'), 1)
                      ], 8, _hoisted_12),
                      (documentSummary.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("p", null, _toDisplayString(documentSummary.value), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ai-summary__close",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (documentSummary.value = ''))
                            }, "Fechar")
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(document.value.interactions, (interaction) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("h4", _hoisted_16, _toDisplayString(interaction.creator.name), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", {
                        innerHTML: interaction.content
                      }, null, 8, _hoisted_18)
                    ]),
                    (interaction.files.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _hoisted_20,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interaction.files, (file) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              _createElementVNode("p", null, _toDisplayString(file.name), 1),
                              _createElementVNode("div", null, [
                                (file.mime_type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (visualizeFile(file)),
                                      class: "tooltip"
                                    }, _hoisted_23, 8, _hoisted_21))
                                  : _createCommentVNode("", true),
                                _createElementVNode("a", {
                                  href: "#",
                                  onClick: ($event: any) => (downloadFile($event, file))
                                }, _hoisted_26, 8, _hoisted_24)
                              ])
                            ]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256)),
                (_unref(hasAiModule) && isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ai-toggle-button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (isAiReplyPanelOpen.value = !isAiReplyPanelOpen.value))
                      }, [
                        _hoisted_28,
                        _createTextVNode(" Sugerir resposta com IA ")
                      ]),
                      (isAiReplyPanelOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _hoisted_30,
                            _withDirectives(_createElementVNode("textarea", {
                              id: "ai-reply-prompt",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((aiReplyPrompt).value = $event)),
                              rows: "2",
                              placeholder: "Ex: Informe que o prazo foi atendido e solicite o próximo passo."
                            }, null, 512), [
                              [_vModelText, aiReplyPrompt.value]
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              (aiUsage.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(aiUsage.value.remaining) + " de " + _toDisplayString(aiUsage.value.limit) + " gerações restantes hoje", 1))
                                : _createCommentVNode("", true),
                              (!isSuggestingAiReply.value)
                                ? (_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "button",
                                    value: "Gerar sugestão",
                                    disabled: !!aiUsage.value && aiUsage.value.remaining <= 0,
                                    onClick: suggestAiReply
                                  }, null, 8, _hoisted_33))
                                : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                                    key: 2,
                                    height: 40,
                                    maxWidth: 160
                                  }))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createBlock(TextEditor, {
                      key: 2,
                      value: updatePayload.value.content,
                      setValue: (value) => updatePayload.value.content = value
                    }, null, 8, ["value", "setValue"]))
                  : _createCommentVNode("", true),
                (_unref(hasAiModule) && isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ai-toggle-button",
                        disabled: !updatePayload.value.content || isReviewingCompliance.value,
                        onClick: reviewCompliance
                      }, [
                        _hoisted_36,
                        _createTextVNode(" " + _toDisplayString(isReviewingCompliance.value ? 'Revisando...' : 'Revisar formalidades com IA'), 1)
                      ], 8, _hoisted_35),
                      (complianceResult.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (complianceResult.value.ok)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_38, "Nenhuma formalidade pendente encontrada."))
                              : (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(complianceResult.value.issues, (issue, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(issue), 1))
                                  }), 128))
                                ]))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (keywords.value.length)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_40, "Palavras chaves"))
                  : _createCommentVNode("", true),
                (keywords.value.length)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_41, "Separe por vírgula, exemplo: férias, pagamento."))
                  : _createCommentVNode("", true),
                (keywords.value.length)
                  ? (_openBlock(), _createBlock(MyTags, {
                      key: 6,
                      value: keywords.value,
                      name: 'keywords',
                      placeholder: 'Digite a palavra chave',
                      disabled: true
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_42, "Arquivo do documento"))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_43, "Adicione um arquivo a esse documento, podendo ser DOC ou PDF."))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createBlock(FileUploader, {
                      key: 9,
                      files: updatePayload.value.files!,
                      pushFile: (file) => updatePayload.value.files!.push(file)
                    }, null, 8, ["files", "pushFile"]))
                  : _createCommentVNode("", true),
                (mentions.value.length)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_44, "Citado(s) no(s) documento(s)"))
                  : _createCommentVNode("", true),
                (mentions.value.length)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_45, "Escreva nome e sobrenome dos participantes citados no(s) anexo(s) e separe por vírgula."))
                  : _createCommentVNode("", true),
                (mentions.value.length)
                  ? (_openBlock(), _createBlock(MyTags, {
                      key: 12,
                      value: mentions.value,
                      name: 'mentions',
                      placeholder: 'Digite nome e sobrenome',
                      disabled: true
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_46, [
                      _createTextVNode(_toDisplayString(isChamber.value ? 'Câmaras' : 'Setores') + " ", 1),
                      _hoisted_47
                    ]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_48, "Quais " + _toDisplayString(isChamber.value ? 'câmaras' : 'setores') + " agora precisam ter acesso a esse documento? Você pode selecionar mais de um.", 1))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createBlock(MyOptions, {
                      key: 15,
                      currentValue: updatePayload.value.organizations?.length ? `${updatePayload.value.organizations.length} ${isChamber.value ? 'câmara(s)' : 'setor(es)'} selecionado(s)` : 'Selecione'
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "item",
                            key: index
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              id: 'organizations-' + index,
                              value: organization.id,
                              checked: updatePayload.value.organizations?.some((o) => o.id === organization.id),
                              onChange: ($event: any) => (toggleUpdateOrganization(organization, ($event.target as HTMLInputElement).checked))
                            }, null, 40, _hoisted_49),
                            _createElementVNode("label", {
                              for: 'organizations-' + index
                            }, [
                              _hoisted_51,
                              _createElementVNode("p", null, _toDisplayString(organization.name), 1)
                            ], 8, _hoisted_50)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["currentValue"]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_52, [
                      _createTextVNode("Responsáveis "),
                      _hoisted_53
                    ]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_54, "Quem agora precisa ter acesso a esse documento? Você pode selecionar mais de uma pessoa."))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createBlock(MyOptions, {
                      key: 18,
                      currentValue: updatePayload.value.responsibles?.length ? `${updatePayload.value.responsibles.length} responsável(is) selecionado(s)` : 'Selecione'
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersToTransfer.value, (responsible, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "item",
                            key: index
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              id: 'responsible-' + index,
                              value: responsible.id,
                              checked: updatePayload.value.responsibles?.some((r) => r.id === responsible.id),
                              onChange: ($event: any) => (toggleUpdateResponsible(responsible, ($event.target as HTMLInputElement).checked))
                            }, null, 40, _hoisted_55),
                            _createElementVNode("label", {
                              for: 'responsible-' + index
                            }, [
                              _hoisted_57,
                              _createElementVNode("p", null, _toDisplayString(responsible.name) + " " + _toDisplayString(responsible.last_name), 1)
                            ], 8, _hoisted_56)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["currentValue"]))
                  : _createCommentVNode("", true),
                (abilities.value.extendDocument)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_58, [
                      _createTextVNode("Data limite "),
                      _hoisted_59
                    ]))
                  : _createCommentVNode("", true),
                (abilities.value.extendDocument)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_60, "Prazo máximo para o documento ser apreciado"))
                  : _createCommentVNode("", true),
                (abilities.value.extendDocument)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 21,
                      class: "date-picker-label",
                      for: "date-limit-document",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {isDatePickerModalOpen.value = true;})
                    }, [
                      _createElementVNode("input", {
                        type: "text",
                        placeholder: "Selecione uma data",
                        name: "date-limit-document",
                        id: "date-limit-document",
                        value: updatePayload.value.limit_date ? formatDate(updatePayload.value.limit_date) : formatDate(document.value.limit_date.slice(0, 10)),
                        readonly: ""
                      }, null, 8, _hoisted_61),
                      _hoisted_62
                    ]))
                  : _createCommentVNode("", true),
                (abilities.value.extendDocument)
                  ? (_openBlock(), _createBlock(MyModal, {
                      key: 22,
                      width: '341px !important',
                      height: '517px !important',
                      className: 'date-limit',
                      isOpen: isDatePickerModalOpen.value,
                      toggleModal: (v) => isDatePickerModalOpen.value = v,
                      zIndex: 100
                    }, {
                      default: _withCtx(() => [
                        _hoisted_63,
                        _createVNode(MyDatePicker, {
                          min: { day: new Date(document.value.limit_date).getDate(), month: new Date(document.value.limit_date).getMonth() + 1, year: new Date(document.value.limit_date).getFullYear() },
                          name: 'limit_date',
                          setValue: (date) => limitDateValue.value = date
                        }, null, 8, ["min", "setValue"]),
                        _createElementVNode("input", {
                          type: "button",
                          value: "Aplicar data",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {updatePayload.value.limit_date = limitDateValue.value; isDatePickerModalOpen.value = false})
                        })
                      ]),
                      _: 1
                    }, 8, ["isOpen", "toggleModal"]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value && abilities.value.transferDocument)
                  ? (_openBlock(), _createBlock(MyModal, {
                      key: 23,
                      width: '776px',
                      height: '1171px',
                      isOpen: isTransferDocumentModalOpen.value,
                      "class-name": 'transfer-document',
                      toggleModal: (v) => isTransferDocumentModalOpen.value = v,
                      zIndex: 100
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("h1", null, [
                            _createTextVNode(_toDisplayString(isChamber.value ? 'Câmaras' : 'Setores') + " ", 1),
                            _hoisted_66
                          ]),
                          _createElementVNode("h2", null, "Quais " + _toDisplayString(isChamber.value ? 'câmaras' : 'setores') + " agora precisam ter acesso a esse documento? Você pode selecionar mais de um.", 1),
                          _createVNode(MyOptions, {
                            currentValue: updatePayload.value.organizations?.length ? `${updatePayload.value.organizations.length} ${isChamber.value ? 'câmara(s)' : 'setor(es)'} selecionado(s)` : 'Selecione'
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "item",
                                  key: index
                                }, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    id: 'organizations-transfer-modal-' + index,
                                    value: organization.id,
                                    checked: updatePayload.value.organizations?.some((o) => o.id === organization.id),
                                    onChange: ($event: any) => (toggleUpdateOrganization(organization, ($event.target as HTMLInputElement).checked))
                                  }, null, 40, _hoisted_67),
                                  _createElementVNode("label", {
                                    for: 'organizations-transfer-modal-' + index
                                  }, [
                                    _hoisted_69,
                                    _createElementVNode("p", null, _toDisplayString(organization.name), 1)
                                  ], 8, _hoisted_68)
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["currentValue"]),
                          _hoisted_70,
                          _hoisted_71,
                          _createVNode(MyOptions, {
                            currentValue: updatePayload.value.responsibles?.length ? `${updatePayload.value.responsibles.length} responsável(is) selecionado(s)` : 'Selecione'
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersToTransfer.value, (responsible, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "item",
                                  key: index
                                }, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    id: 'responsible-transfer-modal-' + index,
                                    value: responsible.id,
                                    checked: updatePayload.value.responsibles?.some((r) => r.id === responsible.id),
                                    onChange: ($event: any) => (toggleUpdateResponsible(responsible, ($event.target as HTMLInputElement).checked))
                                  }, null, 40, _hoisted_72),
                                  _createElementVNode("label", {
                                    for: 'responsible-transfer-modal-' + index
                                  }, [
                                    _hoisted_74,
                                    _createElementVNode("p", null, _toDisplayString(responsible.name) + " " + _toDisplayString(responsible.last_name), 1)
                                  ], 8, _hoisted_73)
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["currentValue"]),
                          _hoisted_75,
                          _hoisted_76,
                          _createVNode(TextEditor, {
                            setValue: (value) => updatePayload.value.content = value
                          }, null, 8, ["setValue"]),
                          _hoisted_77,
                          _hoisted_78,
                          _createVNode(FileUploader, {
                            files: updatePayload.value.files!,
                            pushFile: (file) => updatePayload.value.files!.push(file)
                          }, null, 8, ["files", "pushFile"])
                        ]),
                        _createElementVNode("nav", null, [
                          (!isUpdatingDocument.value)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                disabled: !hasChanges.value,
                                type: "button",
                                value: "Enviar",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (updateDocument()))
                              }, null, 8, _hoisted_79))
                            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                                key: 1,
                                height: 60,
                                maxWidth: 464
                              })),
                          _createElementVNode("input", {
                            type: "button",
                            value: "Cancelar",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => {isTransferDocumentModalOpen.value = false;})
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["isOpen", "toggleModal"]))
                  : _createCommentVNode("", true),
                (isDocumentOpenValue.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_80, [
                      _createElementVNode("nav", null, [
                        (!isUpdatingDocument.value)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "button",
                              value: "Enviar",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (updateDocument())),
                              disabled: !hasChanges.value
                            }, null, 8, _hoisted_81))
                          : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                              key: 1,
                              height: 60,
                              maxWidth: 464
                            })),
                        _createElementVNode("input", {
                          type: "button",
                          value: "Cancelar",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.go(-1)))
                        })
                      ])
                    ]))
                  : (abilities.value.reopenDocument)
                    ? (_openBlock(), _createElementBlock("section", {
                        key: 25,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (isConfirmCompleteDocumentModal.value = true)),
                        class: "actions-doc reopen"
                      }, _hoisted_83))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "historics",
                "data-doc-number": document.value.number
              }, [
                _createElementVNode("div", _hoisted_85, [
                  (isDocumentOpenValue.value && abilities.value.completeDocument)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (openConclusionNoteModal()))
                      }, [
                        (!isDocumentOpenValue.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_86, _hoisted_90))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_91, _hoisted_94)),
                        _createTextVNode(" Concluir ")
                      ]))
                    : (abilities.value.reopenDocument)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (isConfirmCompleteDocumentModal.value = true)),
                          id: "reopen"
                        }, [
                          _hoisted_95,
                          _createTextVNode(" Reabrir ")
                        ]))
                      : _createCommentVNode("", true),
                  (isDocumentOpenValue.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        disabled: !abilities.value.transferDocument,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (isTransferDocumentModalOpen.value = true))
                      }, [
                        _hoisted_97,
                        _createTextVNode(" Transferir ")
                      ], 8, _hoisted_96))
                    : _createCommentVNode("", true),
                  (document.value.current_protocol)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (isProtocolModalOpen.value = true))
                      }, [
                        _hoisted_98,
                        _createTextVNode(" Ver Protocolo ")
                      ]))
                    : _createCommentVNode("", true),
                  (document.value.protocols?.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (isProtocolsListModalOpen.value = true))
                      }, [
                        _hoisted_99,
                        _createTextVNode(" Protocolos ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_100,
                _createElementVNode("div", _hoisted_101, [
                  (document.value.creator?.organization)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_102, [
                        _createTextVNode(_toDisplayString(isChamber.value ? 'Câmara' : 'Setor') + " inicial: ", 1),
                        _createElementVNode("strong", null, _toDisplayString(document.value.creator?.organization?.acronym ? document.value.creator?.organization.acronym : document.value.creator?.organization?.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, [
                    _createTextVNode("Assunto: "),
                    _createElementVNode("strong", null, _toDisplayString(document.value.subject.name), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode("Criado por: "),
                    _createElementVNode("strong", null, _toDisplayString(document.value.creator?.name), 1)
                  ]),
                  (document.value.responsibles && document.value.responsibles.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_103, [
                        _createTextVNode("Responsável: "),
                        _createElementVNode("strong", null, _toDisplayString(document.value.responsibles[0].name), 1),
                        (document.value.responsibles[0].last_name)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_104, _toDisplayString(document.value.responsibles[0].last_name), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, [
                      _createTextVNode("Criado em: "),
                      _createElementVNode("strong", null, _toDisplayString(new Date(document.value.created_at).toLocaleDateString()), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createTextVNode("Data limite: "),
                      _createElementVNode("strong", null, _toDisplayString(new Date(document.value.limit_date).toLocaleDateString()), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "historic-title-actions" }, [
                  _hoisted_105,
                  _createElementVNode("button", {
                    class: "print-btn-icon tooltip",
                    onClick: printHistory
                  }, _hoisted_107)
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _hoisted_109,
                  _createElementVNode("h2", null, "Documento: " + _toDisplayString(document.value.number), 1),
                  _createElementVNode("h3", null, "Título: " + _toDisplayString(document.value.title), 1)
                ]),
                _createElementVNode("div", _hoisted_110, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(document.value.logs.filter(log => log.action !== _unref(DocumentLogActionEnum).VIEW), (log, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_111, [
                      _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(log.creator.name) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_unref(documentLogActionTranslations)[log.action]), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode("Log criado em: "),
                        _createElementVNode("strong", null, _toDisplayString(new Date(log.created_at).toLocaleDateString()) + " ás " + _toDisplayString(new Date(log.created_at).toLocaleTimeString().slice(0, 5)), 1)
                      ]),
                      (log.limit_date)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_112, [
                            _createTextVNode("Vencimento: "),
                            _createElementVNode("strong", null, _toDisplayString(new Date(log.limit_date).toLocaleDateString()), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        (log.responsibles.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_113, [
                              _createElementVNode("strong", null, _toDisplayString(log.creator.name), 1),
                              _createTextVNode(" enviou o documento "),
                              _createElementVNode("strong", null, _toDisplayString(document.value.number), 1),
                              _createTextVNode(" para "),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.responsibles, (responsible, rIndex) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: responsible.id
                                }, [
                                  _createElementVNode("strong", null, _toDisplayString(responsible.name), 1),
                                  _createTextVNode(" da(o) " + _toDisplayString(responsible.organization?.name), 1),
                                  (rIndex < log.responsibles.length - 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(", ")
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128)),
                              _createTextVNode(". ")
                            ]))
                          : (log.action == 'extension')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_114, [
                                _createElementVNode("strong", null, _toDisplayString(log.creator.name), 1),
                                _createTextVNode(" prorrogou a data limite do documento para "),
                                _createElementVNode("strong", null, _toDisplayString(new Date(log.limit_date).toLocaleDateString('pt-BR')), 1)
                              ]))
                            : (log.action == 'completion')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_115, [
                                  _createElementVNode("strong", null, _toDisplayString(log.creator.name), 1),
                                  _createTextVNode(" finalizou o documento "),
                                  _createElementVNode("strong", null, _toDisplayString(document.value.number), 1)
                                ]))
                              : (log.action == 'reopening')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_116, [
                                    _createElementVNode("strong", null, _toDisplayString(log.creator.name), 1),
                                    _createTextVNode(" reabriu o documento "),
                                    _createElementVNode("strong", null, _toDisplayString(document.value.number), 1)
                                  ]))
                                : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 256))
                ]),
                (document.value.notes && document.value.notes.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      _hoisted_118,
                      _createElementVNode("div", _hoisted_119, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(document.value.notes, (note) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "document-notes__item",
                            key: note.id
                          }, [
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("p", _hoisted_121, _toDisplayString(note.title), 1),
                              _createElementVNode("span", _hoisted_122, _toDisplayString(formatDate(note.event_date)), 1)
                            ]),
                            (note.description)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "document-notes__description",
                                  innerHTML: note.description
                                }, null, 8, _hoisted_123))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (documentViews.value.length)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_124, "Vizualizações"))
                  : _createCommentVNode("", true),
                (documentViews.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentViews.value, (view) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_126, [
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(view.creator.name), 1),
                            (view.creator.last_name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(view.creator.last_name), 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(": "),
                            _hoisted_128
                          ]),
                          _createElementVNode("p", null, [
                            _createTextVNode("Log criado em: "),
                            _createElementVNode("strong", null, _toDisplayString(new Date(view.created_at).toLocaleDateString()) + " ás " + _toDisplayString(new Date(view.created_at).toLocaleTimeString().slice(0, 5)), 1)
                          ])
                        ]))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_84)
            ]))
          : _createCommentVNode("", true),
        (abilities.value.completeDocument || abilities.value.reopenDocument)
          ? (_openBlock(), _createBlock(MyModal, {
              key: 1,
              width: !isDocumentOpenValue.value ? '330px !important' : '330px !important',
              height: !isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime() ? '517px !important' : '299px !important',
              isOpen: isConfirmCompleteDocumentModal.value,
              "class-name": !isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime() ? 'confirm-complete-document picker' : 'confirm-complete-document',
              toggleModal: (v) => isConfirmCompleteDocumentModal.value = v,
              zIndex: 100
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (isDocumentOpenValue.value || !(!isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime()))
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        style: _normalizeStyle(!(!isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime()) && !isDocumentOpenValue.value ? 'margin: 0 auto;' : ''),
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "52",
                        height: "52",
                        viewBox: "0 0 52 52",
                        fill: "none"
                      }, _hoisted_132, 4))
                    : _createCommentVNode("", true),
                  _createElementVNode("h1", {
                    style: _normalizeStyle(!isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime() ? 'justify-content: space-between;' : 'justify-content: center;')
                  }, [
                    _createTextVNode(_toDisplayString(!isDocumentOpenValue.value ? 'Reabrir' : 'Concluir') + " processo ", 1),
                    (!isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime())
                      ? (_openBlock(), _createElementBlock("figure", {
                          key: 0,
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (isConfirmCompleteDocumentModal.value = false))
                        }, _hoisted_134))
                      : _createCommentVNode("", true)
                  ], 4),
                  _createElementVNode("h2", {
                    style: _normalizeStyle(!isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime()? 'text-align: start;' : '')
                  }, [
                    _createTextVNode("Quer mesmo " + _toDisplayString(!isDocumentOpenValue.value ? 'reabrir' : 'concluir') + " esse processo? ", 1),
                    _hoisted_135,
                    _createTextVNode(" " + _toDisplayString(isDocumentOpenValue.value ? 'Após conclusão só será possível novas interações se o documento for reaberto.' : '') + " " + _toDisplayString(!(!isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime()) && !isDocumentOpenValue.value ? 'Após conclusão já será possível ser feita novas interações.' : ''), 1)
                  ], 4),
                  (!isDocumentOpenValue.value && new Date(document.value.limit_date).getTime() < new Date().getTime())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                        _createVNode(MyDatePicker, {
                          min: { day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() },
                          setValue: (v) => updatePayload.value.limit_date = v,
                          name: "limit"
                        }, null, 8, ["min", "setValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", null, [
                    (!isUpdatingDocument.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (updateDocument(!isDocumentOpenValue.value ? _unref(DocumentStatusEnum).UNDER_REVIEW : _unref(DocumentStatusEnum).COMPLETED)))
                        }, "Sim"))
                      : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                          key: 1,
                          isButton: false
                        })),
                    _createElementVNode("input", {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => {isConfirmCompleteDocumentModal.value = false;}),
                      type: "button",
                      value: "Cancelar"
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["width", "height", "isOpen", "class-name", "toggleModal"]))
          : _createCommentVNode("", true),
        (abilities.value.completeDocument)
          ? (_openBlock(), _createBlock(MyModal, {
              key: 2,
              width: '640px !important',
              height: 'fit-content !important',
              isOpen: isConclusionNoteModalOpen.value,
              "class-name": 'conclusion-note',
              toggleModal: (v) => closeConclusionNoteModal(v),
              zIndex: 100
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_137, [
                  _hoisted_138,
                  _createElementVNode("div", _hoisted_139, [
                    _hoisted_140,
                    _createElementVNode("div", {
                      class: _normalizeClass(["editor-wrapper", { 'editor-wrapper--error': showConclusionNoteError.value && isConclusionNoteEmpty.value }])
                    }, [
                      (isConclusionNoteModalOpen.value)
                        ? (_openBlock(), _createBlock(TextEditor, {
                            key: conclusionNoteEditorKey.value,
                            value: conclusionNote.value,
                            setValue: (value) => conclusionNote.value = value
                          }, null, 8, ["value", "setValue"]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (showConclusionNoteError.value && isConclusionNoteEmpty.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_141, "A nota de conclusão é obrigatória."))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("nav", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "submit",
                      disabled: isConclusionNoteEmpty.value,
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (confirmConclusionNote()))
                    }, "concluir documento", 8, _hoisted_142),
                    _createElementVNode("button", {
                      type: "button",
                      class: "cancel",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (closeConclusionNoteModal(false)))
                    }, "cancelar")
                  ])
                ])
              ]),
              _: 1
            }, 8, ["isOpen", "toggleModal"]))
          : _createCommentVNode("", true),
        _createVNode(MyModal, {
          isOpen: isFileVisualizerOpen.value,
          class: _normalizeClass('docView'),
          toggleModal: (v) => isFileVisualizerOpen.value = v,
          width: '80rem',
          height: '50rem',
          zIndex: 10
        }, {
          default: _withCtx(() => [
            (fileVisualizerSrc.value)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  src: fileVisualizerSrc.value,
                  width: "100%",
                  height: "100%"
                }, null, 8, _hoisted_143))
              : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"]),
        (document.value?.current_protocol)
          ? (_openBlock(), _createBlock(MyModal, {
              key: 3,
              isOpen: isProtocolModalOpen.value,
              "class-name": 'digital-protocol',
              toggleModal: (v) => isProtocolModalOpen.value = v,
              zIndex: 100,
              width: '440px',
              height: '630px'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_144, [
                  _hoisted_145,
                  _hoisted_146,
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _hoisted_149,
                      _createElementVNode("span", _hoisted_150, [
                        _createTextVNode("Documento"),
                        _hoisted_151,
                        _createElementVNode("strong", null, _toDisplayString(document.value.number), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _hoisted_153,
                      _createElementVNode("span", _hoisted_154, [
                        _createTextVNode("Ofício/portaria"),
                        _hoisted_155,
                        _createElementVNode("strong", null, _toDisplayString(document.value.physical_document_number || '-'), 1)
                      ])
                    ])
                  ]),
                  _hoisted_156,
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("div", _hoisted_158, [
                      _hoisted_159,
                      _createElementVNode("span", _hoisted_160, [
                        _createTextVNode("Data"),
                        _hoisted_161,
                        _createElementVNode("strong", null, _toDisplayString(formatBrazilDate(document.value.current_protocol.created_at)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_162, [
                      _hoisted_163,
                      _createElementVNode("span", _hoisted_164, [
                        _createTextVNode("Horas"),
                        _hoisted_165,
                        _createElementVNode("strong", null, _toDisplayString(formatBrazilTime(document.value.current_protocol.created_at)), 1)
                      ])
                    ])
                  ]),
                  _hoisted_166,
                  _createElementVNode("div", _hoisted_167, [
                    _hoisted_168,
                    _createElementVNode("span", _hoisted_169, [
                      _createElementVNode("strong", null, _toDisplayString(document.value.current_protocol.creator?.name) + " " + _toDisplayString(document.value.current_protocol.creator?.last_name || ''), 1)
                    ])
                  ]),
                  _hoisted_170,
                  _createElementVNode("div", _hoisted_171, [
                    _hoisted_172,
                    _createElementVNode("span", _hoisted_173, [
                      _createElementVNode("strong", null, _toDisplayString(String(document.value.current_protocol.number).padStart(3, '0')) + _toDisplayString(document.value.current_protocol.organization?.acronym ? ' - ' + document.value.current_protocol.organization.acronym : ''), 1)
                    ])
                  ]),
                  _createElementVNode("div", { class: "actions" }, [
                    _createElementVNode("button", {
                      class: "btn-save",
                      onClick: downloadProtocolFile
                    }, [
                      _createTextVNode(" salvar "),
                      _hoisted_174
                    ]),
                    _createElementVNode("button", {
                      class: "btn-print",
                      onClick: printProtocolFile
                    }, [
                      _hoisted_175,
                      _createTextVNode(" imprimir ")
                    ])
                  ])
                ]),
                _hoisted_176
              ]),
              _: 1
            }, 8, ["isOpen", "toggleModal"]))
          : _createCommentVNode("", true),
        (document.value?.protocols?.length)
          ? (_openBlock(), _createBlock(MyModal, {
              key: 4,
              isOpen: isProtocolsListModalOpen.value,
              "class-name": 'protocols-list',
              toggleModal: (v) => isProtocolsListModalOpen.value = v,
              zIndex: 100,
              width: '650px',
              height: 'fit-content'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_177, [
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("div", { class: "header-top" }, [
                      _hoisted_179,
                      _createElementVNode("button", {
                        class: "btn-print-all",
                        onClick: printAllProtocols
                      }, [
                        _hoisted_180,
                        _createTextVNode(" Imprimir/Baixar ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_181, [
                      _hoisted_182,
                      _createElementVNode("span", _hoisted_183, [
                        _createTextVNode("Documento "),
                        _createElementVNode("strong", null, _toDisplayString(document.value.number), 1),
                        _createTextVNode(" • Ofício/portaria "),
                        _createElementVNode("strong", null, _toDisplayString(document.value.physical_document_number || '-'), 1)
                      ])
                    ])
                  ]),
                  _hoisted_184,
                  _createElementVNode("div", _hoisted_185, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(document.value.protocols, (protocol) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "protocol-card",
                        key: protocol.id
                      }, [
                        _createElementVNode("div", _hoisted_186, [
                          _createElementVNode("span", _hoisted_187, _toDisplayString(protocol.organization?.name) + " (" + _toDisplayString(protocol.organization?.acronym) + ")", 1),
                          _createElementVNode("div", _hoisted_188, [
                            _createElementVNode("span", _hoisted_189, _toDisplayString(String(protocol.number).padStart(3, '0')) + _toDisplayString(protocol.organization?.acronym ? ' - ' + protocol.organization.acronym : ''), 1),
                            _createElementVNode("div", _hoisted_190, [
                              _createElementVNode("button", {
                                class: "btn-action",
                                title: "Salvar",
                                onClick: ($event: any) => (downloadProtocolFile(protocol))
                              }, _hoisted_193, 8, _hoisted_191),
                              _createElementVNode("button", {
                                class: "btn-action",
                                title: "Imprimir",
                                onClick: ($event: any) => (printProtocolFile(protocol))
                              }, _hoisted_196, 8, _hoisted_194)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_197, [
                          _createElementVNode("div", _hoisted_198, [
                            _hoisted_199,
                            _createElementVNode("span", _hoisted_200, _toDisplayString(protocol.creator?.name) + " " + _toDisplayString(protocol.creator?.last_name || ''), 1)
                          ]),
                          _createElementVNode("div", _hoisted_201, [
                            _hoisted_202,
                            _createElementVNode("span", _hoisted_203, _toDisplayString(formatBrazilDate(protocol.created_at)) + " às " + _toDisplayString(formatBrazilTime(protocol.created_at)), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["isOpen", "toggleModal"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})